import React, { useState } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import './ChatComponent.css';

// Registrierung der Komponenten
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const ChartComponent = ({ contracts }) => {
    const [selectedField, setSelectedField] = useState('Institut');
    const [chartType, setChartType] = useState('Bar'); // 'Bar' oder 'Pie'
    const [dataType, setDataType] = useState('count'); // 'count', 'NumOfUnits', 'NumOfUnitsTeaching', 'total'

    const handleFieldChange = (event) => {
        setSelectedField(event.target.value);
    };

    const handleChartTypeChange = (event) => {
        setChartType(event.target.value);
    };

    const handleDataTypeChange = (event) => {
        setDataType(event.target.value);
    };

    function getLeadingEmployment(employments) {
        const leading = employments.find(emp => emp.IsLeading === true || emp.IsLeading === 1);
        return leading || employments[0];
    }

    // Funktion zur Aggregation der Daten basierend auf dem ausgewählten Feld und Datentyp
    const aggregateData = (field, type) => {
        const aggregation = {};

        contracts.forEach((contract) => {
            contract.employments.forEach((employment) => {
                let key;
                switch (field) {
                    case 'Nachname':
                        key = contract.employee.FamilyName;
                        break;
                    case 'Institut':
                        key = employment.orgUnit.Name;
                        break;
                    case 'Status':
                        key = contract.contract.Status;
                        break;
                    case 'federalState':
                        key = contract.federalState.Shortname;
                        break;
                    default:
                        key = '';
                }

                if (key) {
                    if (!aggregation[key]) {
                        aggregation[key] = 0;
                    }

                    // Aggregation je nach Datentyp
                    switch (type) {
                        case 'count':
                            aggregation[key]++;
                            break;
                        case 'NumOfUnits':
                            aggregation[key] += employment.employment.NumOfUnits || 0;
                            break;
                        case 'NumOfUnitsTeaching':
                            aggregation[key] += employment.employment.NumOfUnitsTeaching || 0;
                            break;
                        case 'total':
                            aggregation[key] += (employment.employment.NumOfUnits || 0) + (employment.employment.NumOfUnitsTeaching || 0);
                            break;
                        default:
                            break;
                    }
                }
            });
        });

        return aggregation;
    };

    const aggregatedData = aggregateData(selectedField, dataType);
    const labels = Object.keys(aggregatedData);
    const data = Object.values(aggregatedData);

    const chartData = {
        labels: labels,
        datasets: [
            {
                label: `Daten für ${selectedField} (${dataType})`,
                data: data,
                backgroundColor: labels.map(() => `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.6)`),
                borderColor: labels.map(() => `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 1)`),
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        scales: chartType === 'Bar' ? {
            y: {
                beginAtZero: true,
            },
        } : {},
    };

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-4">
                    <label htmlFor="chartTypeSelect" className="small-font">Diagrammtyp:</label>
                    <select id="chartTypeSelect" value={chartType} onChange={handleChartTypeChange} className="form-select">
                        <option value="Bar">Balkendiagramm</option>
                        <option value="Pie">Tortendiagramm</option>
                    </select>
                </div>
                <div className="col-12 col-md-4">
                    <label htmlFor="fieldSelect" className="small-font">Feld auswählen:</label>
                    <select id="fieldSelect" value={selectedField} onChange={handleFieldChange} className="form-select">
                        <option value="Institut">Institut</option>
                        <option value="Status">Status</option>
                        <option value="federalState">Land</option>
                        <option value="Nachname">Nachname</option>
                    </select>
                </div>
                <div className="col-12 col-md-4">
                <label htmlFor="dataTypeSelect" className="small-font">Datentyp auswählen:</label>
                    <select id="dataTypeSelect" value={dataType} onChange={handleDataTypeChange} className="form-select">
                        <option value="count">Anzahl</option>
                        <option value="NumOfUnits">Planend</option>
                        <option value="NumOfUnitsTeaching">Lehrend</option>
                        <option value="total">Gesamt (Planend + Lehrend)</option>
                    </select>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-12">
                    {chartType === 'Bar' ? (
                        <Bar data={chartData} options={options} />
                    ) : (
                        <Pie data={chartData} options={options} />
                    )}
                </div>
            </div>
        </>
    );
};

export default ChartComponent;
